<template>
  <div class="config-app">
    <h2 class="app-title">Bens</h2>
    <p class="subtitle">Permite você habilitar e configurar as preferências do módulo de gestão de bens.</p>

    <app-tab :active="active" :menu="menu" @changeTab="(item) => active = item.name">
      <div v-if="active === 'basico'" class="app-input-container">
        <app-label-wrapper style="width: 100% !important; flex: 1" class="m-t" label="Permitir Venda Direta">
          <div class="m-t-xs"><u-checkbox v-model="config.c('bem.permitirVendaDireta', true, 'user').value" /> Sim, permitir</div>
        </app-label-wrapper>

        <app-label-wrapper label="Gestão dos Bens">
          <u-select :options="[{label: 'Padrão Leiloeiro', value: '0'},{label: 'Gestão Avançada', value: '1'}]" class="app-input" hide-underline v-model="c('bem.tipoGestao').value" />
        </app-label-wrapper>

        <app-label-wrapper>
          <template v-slot:label-content>
            <div class="m-t col-grow">
              <u-btn @click="$emit('salvar')" :loading="config.loading" label="Salvar configuações" no-caps color="green" class="app-btn" />
            </div>
          </template>
        </app-label-wrapper>
      </div>
      <list v-if="active === 'campos'" class="app-input-container" />
      <list-campo-secao-bem v-if="active === 'camposSecao'" class="app-input-container" />
      <list-eventos-bem v-if="active === 'eventos'" class="app-input-container" />
      <list-checklist-secao-bem v-if="active === 'checklistSecao'" class="app-input-container" />
      <bem-config-checklist v-if="active === 'checklist'" class="app-input-container" />
      <bem-config-tarefas v-if="active === 'tarefas'" class="app-input-container" />
    </app-tab>
  </div>
</template>

<script>
import AppMixin from './appMixin'
import List from "@/components/cadastro/components/campobem/List"
import {USelect, UCheckbox} from "uloc-vue"
import BemConfigChecklist from "@/components/globalconfig/components/apps/bem/checklist/Checklist"
import BemConfigTarefas from "@/components/globalconfig/components/apps/bem/tarefas/Checklist"
import ListEventosBem from "@/components/cadastro/components/eventosbem/List"
import ListCampoSecaoBem from "@/components/cadastro/components/camposecaobem/List"
import ListChecklistSecaoBem from "@/components/cadastro/components/checklistsecaobem/List";

export default {
  name: "ConfigTarefas",
  inject: ['config'],
  components: {
    ListChecklistSecaoBem,
    ListCampoSecaoBem,
    ListEventosBem,
    BemConfigTarefas,
    BemConfigChecklist,
    List,
    USelect,
    UCheckbox
  },
  mixins: [AppMixin],
  data() {
    return {
      active: 'basico'
    }
  },
  computed: {
    menu() {
      return [
        {
          name: 'basico',
          label: 'Básico'
        },
        {
          name: 'eventos',
          label: 'Eventos'
        },
        {
          name: 'camposSecao',
          label: 'Seção de Campos'
        },
        {
          name: 'campos',
          label: 'Campos'
        },
        {
          name: 'checklistSecao',
          label: 'Seção de Checklists'
        },
        {
          name: 'checklist',
          label: 'Checklist automático'
        },
        {
          name: 'tarefas',
          label: 'Tarefas / Providências'
        }
      ]
    }
  }
}
</script>
